import { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import "./ServiceFAQ.css";

const ServiceFAQ = ({ faqs = [] }) => {
  const [active, setActive] = useState(null);

  const handleToggle = (index) => {
    setActive(active === index ? null : index);
  };

  return (
    <section className="service-faq">
      <div className="faq-container">
        <div className="faq-heading">
          <span className="section-tag-faq">FAQ</span>

          <h2>Frequently Asked Questions</h2>

          <p>
            Everything you need to know before starting your sports
            infrastructure project.
          </p>
        </div>

        <div className="faq-list">
          {faqs.map((item, index) => (
            <div
              className={`faq-item ${active === index ? "active" : ""}`}
              key={index}
            >
              <button
                type="button"
                className="faq-question"
                onClick={() => handleToggle(index)}
                aria-expanded={active === index}
              >
                <span>{item.question}</span>

                <FaChevronDown />
              </button>

              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceFAQ;
